export const SERVER_ADDRESS = 'thelightofempire.com';
export const SERVER_ADDRESS_IP = '89.100.121.194';

export const CONNECT_URL = `steam://connect/${SERVER_ADDRESS}`;
export const CONNECT_URL_IP = `steam://connect/${SERVER_ADDRESS_IP}`;
